const CLOCK_FORMAT = /^(\d{1,3}):([0-5]\d)$/;
const DECIMAL_FORMAT = /^\d+(?:\.\d+)?$/;

export type ParsedTimeInput =
  | {
      ok: true;
      hours: number;
    }
  | {
      ok: false;
      error: string;
    };

export function parseTimeEntryHours(rawValue: string): ParsedTimeInput {
  const value = rawValue.trim();

  if (!value) {
    return { ok: false, error: 'Enter time.' };
  }

  const clockMatch = value.match(CLOCK_FORMAT);
  if (clockMatch) {
    const hours = Number(clockMatch[1]);
    const minutes = Number(clockMatch[2]);
    const decimalHours = hours + minutes / 60;

    if (decimalHours <= 0) {
      return { ok: false, error: 'Time must be greater than zero.' };
    }

    return { ok: true, hours: roundHours(decimalHours) };
  }

  if (DECIMAL_FORMAT.test(value)) {
    const hours = Number(value);
    if (!Number.isFinite(hours) || hours <= 0) {
      return { ok: false, error: 'Time must be greater than zero.' };
    }

    return { ok: true, hours: roundHours(hours) };
  }

  return { ok: false, error: 'Use decimal hours or HH:MM.' };
}

export function roundHours(hours: number) {
  return Math.round(hours * 10000) / 10000;
}

export function elapsedSecondsToHours(seconds: number) {
  return roundHours(seconds / 3600);
}

export function formatElapsedClock(totalSeconds: number) {
  const normalized = Math.max(0, Math.floor(totalSeconds));
  const hours = Math.floor(normalized / 3600);
  const minutes = Math.floor((normalized % 3600) / 60);
  const seconds = normalized % 60;

  if (hours > 0) {
    return `${hours}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  }

  return `${minutes}:${String(seconds).padStart(2, '0')}`;
}

export function formatClockInput(hours: number) {
  const totalMinutes = Math.round(hours * 60);
  const clockHours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  return `${String(clockHours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
}
